import { Component, OnInit, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ResSearchService } from './resSearch.service';
import { Member } from 'src/app/model/member.model';
import { ResSearch } from 'src/app/model/reservation.model';
import { NgxSignatureOptions, NgxSignaturePadComponent } from '@eve-sama/ngx-signature-pad';
import { environment } from 'src/environments/environment';
import { ScrollPanel } from 'primeng/scrollpanel';
import liff from '@line/liff';

@Component({
  selector: 'app-resSearch',
  templateUrl: './resSearch.component.html',
  styleUrl: './resSearch.component.css'
})
export class ResSearchComponent implements OnInit {
  @ViewChild('sig', { static: false }) pad!: NgxSignaturePadComponent;
  /** 同意書Scroll */
  @ViewChild('consentFormScrollPanel') public scrollPanel: ScrollPanel;
  options: NgxSignatureOptions = {
      backgroundColor: '#fff',
      width: 500,
      height: 500
  };
  CompanyID: string;
  UserID: string;
  Liff_ID: string;
  UserName: string;
  LoginUser: Member;
  /**表單內容 */
  model: ResSearch[] = []; 
  /**預覽表單 */
  editModel: any = {}; 
  /**紀錄簽名檔的資料 */
  drawData: ResSearch;
  /**畫面載入 */
  isOptionLoading: boolean = false;
  loading: boolean = false;
  showDialog: boolean = false;
  isConsentLoading: boolean = false;
  baseUrl = environment.baseUrl;
  ResNeedReply: boolean = false;
  BookNeedReply: boolean = false;
  /** 同意書內容 */
  public consentFormContent: string;
  /** 是否已閱讀完同意書(滾動至最底) */
  public isConsentFormRead: boolean = false;
  isScrollBottom = false;
  subscribes: Subscription = new Subscription();
  constructor(
        private route: ActivatedRoute,
        private ResSearchService: ResSearchService,
        private router: Router,
        private authenticationService: AuthenticationService
  ){}
  ngOnInit(): void {
      var that = this;
      // 取得querystring param
      var query = this.route.queryParams.subscribe((value) => {
        this.CompanyID = value['CompanyID'];
        this.UserID = value['UserID'];
        this.Liff_ID = value['Liff_ID'];
      });

      var currentUser = this.authenticationService.currentMember.subscribe(
        (member) => {
          this.LoginUser = member;
        }
      );

      this.subscribes.add(query);
      this.subscribes.add(currentUser);
      
      this.subscription();
  }
  //#region   初始化設定
    /**取得門市與服務項目 */
    subscription() {
      this.isOptionLoading = true;
      var subject = new BehaviorSubject<boolean>(false);
      //取得門市與服務項目
      var GetDefaultData = this.ResSearchService.SearchResData(
        this.CompanyID,
        this.UserID
      ).subscribe((res) => {
        if(!!res.ErrorFlag && res.ErrorFlag == '2'){
                Swal.fire({
                          icon: 'error',
                          title: "您目前無法進行預約，請聯絡該門市，謝謝。",
                          confirmButtonText: '確定'
                        }).then((result) => {
                          if (result.isConfirmed) {
                            this.router.navigate(['/'],{
                              queryParams: {
                                CompanyID: this.CompanyID,
                                UserID: this.UserID,
                                Liff_ID: this.Liff_ID
                              },
                            });
                          }
                        });
                        
                        return;
        }
        if (res.ErrorFlag == "1") {
          Swal.fire({
            icon: 'error',
            title: res.ErrorMsg,
          });
        } else {
          this.getDataSucceed(res);
          subject.next(true);
          subject.complete();
        }
      });
      this.subscribes.add(GetDefaultData);
      return subject.asObservable();
    }
  //#endregion
  //#region   相關事件
  getDataSucceed(res: any) { 
    this.model = res.resData; 
    this.model.forEach(s=>{
      s.Content = [
        s.StoreName ? `門市: ${s.StoreName}` : null,
        s.RemindDateS ? `預約日期: ${s.RemindDateS}` : null,
        s.RemindDateE ? `至 ${s.RemindDateE}` : null,
        s.TimeFrom ? `預約時間: ${s.TimeFrom}` : null,
        s.Service ? `預約服務: ${s.Service}` : null,
        s.Room ? `房型: ${s.Room}` : null,
        s.Price ? `費用: ${s.Price}元` : null
      ]
      .filter(x => x)    // null / undefined / "" 會被移除
      .join("\n");
    }); 
    this.ResNeedReply = res.cancelReplyForRes??false;
    this.BookNeedReply = res.cancelReplyForBook??false;
    this.isOptionLoading = false;
  }
  Cancel(rowData: ResSearch){
    Swal.fire({
      title: "確定要取消該筆預約嗎?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "確定",
      cancelButtonText:"取消"
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      this.loading = true;
      try {
        const res = await import('rxjs').then(m => m.firstValueFrom(
          this.ResSearchService.CancelReservation(rowData)
        ));
        if (res.ErrorFlag === "1") {
          Swal.fire({ icon: 'error', title: res.ErrorMsg });
          this.loading = false; // 發生錯誤時，立刻關別讀取狀態
          return;
        }
        await this.getCancelSucceed(rowData);
      }catch (err: any) {
        this.handleError(err.message || '取消預約請求失敗');
        this.loading = false;
      }
        
    });
  }
  
  /**簽名 */
  Sign(rowData: ResSearch) {
      this.showDialog = true;
      this.isConsentLoading = true;
      this.consentFormContent = "";
      this.drawData = rowData;
      this.drawData.UserID = this.UserID;
      this.isConsentFormRead = false;
              this.ResSearchService.GetConsentForm(this.drawData).subscribe((result: any)=>{
                this.isConsentLoading = false;
                if (result?.ErrorFlag === '1'){
                  Swal.fire({
                    icon: 'error',
                    title: '錯誤資訊：' + result.ErrorMsg,
                  });
                  return;
                }
                this.consentFormContent = result;
                if (this.pad) {
                  if (!this.scrollPanel?.contentViewChild) return;
                   // 當有開啟簽名板時，檢查是否有閱讀完同意書，再開啟確認按鈕
                   this.scrollPanel.contentViewChild.nativeElement.addEventListener('scroll', this.onCheckSignatureAndReadConsentForm.bind(this));
                }   
              });
  }
  /** 檢查是否簽名並且閱讀同意書 */
  private onCheckSignatureAndReadConsentForm(event: Event) {
      if (!this.scrollPanel?.contentViewChild) return;
      const scrollElement = this.scrollPanel.contentViewChild.nativeElement;
      // 計算是否滾動到底部
      const isScrollToBottom = scrollElement.scrollHeight - scrollElement.scrollTop - scrollElement.clientHeight <= 1; // 誤差值 1
      this.isConsentFormRead = isScrollToBottom;
      if(this.isConsentFormRead)
        this.isScrollBottom = true;
  }
  /**清除簽名
  */
  clear() {
      this.pad.clear();
  }
  /**儲存簽名 */
  save() {
      if (this.pad.isEmpty()) {
          alert('請先簽名');
          return;
      }
      const dataURL = this.pad.toDataURL();
      this.drawData.SignPath = dataURL;
      this.ResSearchService.SaveSign(this.drawData).subscribe((res: any)=>{ 
        this.showDialog = false; 
        this.drawData.SignPath = res;
        //最後記得清除
        this.pad.clear();
      });
  }
  onBegin() { 
    document.querySelector('.sign-box')?.classList.add('signing');
  }
  onEnd() { /* 結束簽名事件 */ }
  onSidebarHide() {
    this.clear(); // 關閉時自動清除
  }
  //#endregion
  //#region   基本設定
  async getCancelSucceed(res: ResSearch){
      this.model = this.model.filter(s=> s.TargetNo != res.TargetNo);

      const isGroomingNeedReply = res.Type === '美容' && this.ResNeedReply;
      const isHotelNeedReply = res.Type === '住宿' && this.BookNeedReply;

      if (isGroomingNeedReply || isHotelNeedReply) {
        await this.CreateReserveSucceed(res);
      }
      
      this.loading = false;
      Swal.fire({
        title: "取消成功!",
        icon: "success",
        draggable: true
      });
  }
  CheckDisable(rowData: ResSearch){
      var result = false;
      function buildReserveDate(time: string): Date {
        const [hour, minute] = time.split(':').map(Number);

        const now = new Date();
        const reserve = new Date();
        reserve.setHours(hour, minute, 0, 0);

        // 若預約時間早於現在，表示是隔天
        if (reserve <= now) {
          reserve.setDate(reserve.getDate() + 1);
        }

        return reserve;
      }

      if(rowData.Type == "美容"){
        //已填入消費日期和已結帳不可取消
        if(!!rowData.ConsumeDate || !!rowData.SaleNo) return true;
        //預約前1小時不可取消
        const now = new Date();
        const oneHourMs = 60 * 60 * 1000;
        const reserveTime = buildReserveDate(rowData.TimeFrom); 
        const diffMs = reserveTime.getTime() - now.getTime();
        result = diffMs <= oneHourMs;
      }else{
        result = rowData.ReservationFlag == "2";
      }

      return result;
  }
  /**美容預約取消回覆 */ 
  async CreateReserveSucceed(res: ResSearch) {
      try {
        await liff.init({ liffId: this.Liff_ID });
        
        if (!liff.isInClient()) {
              this.handleError('請從 LINE 聊天中開啟此頁面才能發送訊息');
              return;
        }
        let lines: (string | undefined)[] = [];
        if (res.Type === '美容'){
          lines = [
            '美容預約取消通知，以下為預約資訊：',
              res.RemindDateS ? `日期時間： ${res.RemindDateS} ${res.TimeFrom}-${res.TimeTo}` : undefined,
              res.Service ? `服務項目： ${res.Service}` : undefined,
              res.MemberName ? `飼主： ${res.MemberName}` : undefined,
              res.PetName ? `寵物： ${res.PetName}` : undefined,
              `通知內容： 本次美容預約取消`
          ];
        }else if(res.Type === '住宿'){
          lines = [
            '住宿預約取消通知，以下為預約資訊：',
              res.RemindDateS ? `住宿期間： ${res.RemindDateS}-${res.RemindDateE}` : undefined,
              res.Room ? `住宿房型： ${res.Room}` : undefined,
              res.MemberName ? `飼主： ${res.MemberName}` : undefined,
              res.PetName ? `寵物： ${res.PetName}` : undefined,
              `通知內容： 本次住宿約預取消`
          ];
        }
        
        const safeLines: string[] = lines.filter((x): x is string => !!x);
  
        const content = safeLines.join('\n');
  
        // 發送訊息
        await liff.sendMessages([{ type: 'text', text: content}]);
  
      }catch(err: any){
        this.handleError(err.message || 'LINE 訊息發送失敗');
      }
      
  }
  /**
     * 處理錯誤彈窗
     * @param msg 錯誤訊息內容
     * @param isFatal 是否為嚴重錯誤（如果是，關閉彈窗後導回首頁）
     */
  private handleError(msg: string, isFatal: boolean = false): void {
      Swal.fire({
        icon: 'error',
        title: '抱歉，發生錯誤',
        text: msg,
        confirmButtonText: '確定',
        confirmButtonColor: '#d33', // 習慣上錯誤用紅色
        allowOutsideClick: !isFatal // 嚴重錯誤不允許點擊外面關閉
      }).then((result) => {
        if (isFatal && result.isConfirmed) {
          // 導回首頁，並帶上必要的參數以免 LIFF 失效
          this.router.navigate(['/'], { 
            queryParams: { 
              CompanyID: this.CompanyID, 
              UserID: this.UserID, 
              Liff_ID: this.Liff_ID 
            } 
          });
        }
      });
  }
  //#endregion
  ngOnDestroy() {
    this.subscribes.unsubscribe();
  }
}
